import { useState, useEffect } from 'react';
import { getAllGroceryShops, setGroceryShopActive, deleteGroceryShop } from '../services/adminApi';

export const useAdminGroceryShops = () => {
  const [groceryShops, setGroceryShops] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchGroceryShops = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await getAllGroceryShops({ include_inactive: true });
      setGroceryShops(Array.isArray(response) ? response : []);
    } catch (err) {
      console.error('Erreur chargement grocery shops:', err);
      if (err.message?.includes('401') || err.message?.includes('Unauthorized')) {
        setError('Session expirée - veuillez vous reconnecter');
      } else {
        setError(err.message || 'Erreur lors du chargement des grocery shops');
      }
      setGroceryShops([]);
    } finally {
      setLoading(false);
    }
  };

  const suspendGroceryShopById = async (groceryShopId) => {
    try {
      await setGroceryShopActive(groceryShopId, false);
      await fetchGroceryShops();
      return { success: true };
    } catch (err) {
      console.error('Erreur suspension grocery shop:', err);
      return { success: false, error: err.message };
    }
  };

  const activateGroceryShopById = async (groceryShopId) => {
    try {
      await setGroceryShopActive(groceryShopId, true);
      await fetchGroceryShops();
      return { success: true };
    } catch (err) {
      console.error('Erreur activation grocery shop:', err);
      return { success: false, error: err.message };
    }
  };

  const deleteGroceryShopById = async (groceryShopId) => {
    try {
      await deleteGroceryShop(groceryShopId);
      await fetchGroceryShops();
      return { success: true };
    } catch (err) {
      console.error('Erreur suppression grocery shop:', err);
      return { success: false, error: err.message };
    }
  };

  useEffect(() => {
    fetchGroceryShops();
  }, []);

  return {
    groceryShops,
    loading,
    error,
    suspendGroceryShopById,
    activateGroceryShopById,
    deleteGroceryShopById,
    refetch: fetchGroceryShops,
  };
};
